import { rfqConfirmationHeaderStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader";
import { css } from "styled-components";

rfqConfirmationHeaderStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 2, 7, 7],
};
rfqConfirmationHeaderStyles.titleGridItem = {
    width: [10, 10, 10, 5, 5],
};
